<template>
    <div class="layout__padding-clear">
        <div class="layout__position__relative">
            <img class="layout__width-100 layout__height-100 layout__padding-clear"
                 src="https://rpsassets.blob.core.windows.net/rpsimages/images/banners/MyRavensworth-banners-pf.jpg">
            <div class="layout__padding-clear">
                <div class="component__banner-subtitle layout__padding-clear">
                    <!--<div class="layout__padding-30px">-->
                        <!--<img class="layout__width-250px" src="https://rpsassets.blob.core.windows.net/rpsimages/images/logos/photofixrWhite.png">-->
                    <!--</div>-->
                    <!--<div class="layout__width-50 layout__padding-clear">-->
                        <!--Give your property portfolio a competitive edge and let us improve your property photos-->
                    <!--</div>-->
                    <div class="text__align-center">
                        <el-button class="button__background-red button__base__header-large layout__width-200px"
                                   v-on:click="activeUploadDialogue = true">Get Started
                        </el-button>
                    </div>
                </div>
            </div>
        </div>

        <div class="">


            <div class="layout__width-40 layout__padding-clear">


                <div class="">
                    <div class="layout__padding-clear layout__width-100">
                        <el-radio-group v-model="activeComponent" :max="1"
                                        class="layout__padding-clear layout__width-100">
                            <div class="component__columns-2__no-padding">
                                <div class="layout__margin-0-10">
                                    <el-radio-button class="layout__width-100 layout__padding-60px-0" label="service"
                                                     :key="'service'">Services
                                    </el-radio-button>
                                </div>
                            </div>
                            <div class="component__columns-2__no-padding">
                                <div class="layout__margin-0-10">
                                    <el-radio-button class="layout__width-100 layout__padding-60px-0" label="pricing"
                                                     :key="'pricing'">Pricing
                                    </el-radio-button>
                                </div>
                            </div>
                        </el-radio-group>
                    </div>
                </div>
            </div>
        </div>

        <div class="layout__padding-clear" v-show="activeComponent === 'service'">
            <Services></Services>
        </div>

        <div class="layout__padding-clear" v-show="activeComponent === 'pricing'">
            <Pricing></Pricing>
        </div>

        <el-button class="layout__display-none" id="startPhotofixrUpload"
                   v-on:click="activeUploadDialogue = true"></el-button>


        <el-dialog
                :visible.sync="activeUploadDialogue"
                :close-on-press-escape="false"
                :close-on-click-modal="false"
                width="500px">
            <div class="component__login-dialogue layout__padding-clear" v-show="activeUploadDialogue">
                <FileUpload></FileUpload>
            </div>
        </el-dialog>
    </div>

</template>

<script>
    import Services from "../../../components/tools/photofixr/Services";
    import Pricing from "../../../components/tools/photofixr/Pricing.vue";
    import FileUpload from "../../../components/tools/photofixr/FileUpload.vue";

    export default {
        name: "photofixrLanding",
        props: {},
        components: {
            FileUpload,
            Services,
            Pricing
        },
        mixins: [],
        data() {
            return {
                activeComponent: 'service',
                rules: {},
                activeUploadDialogue: false,
                fileTypeErrors: []


            }
        },
        created() {
        },
        methods: {},
    };
</script>